class HintService {
  async allHints({ condition }) {
    try {
      const res = await window.axios.get(`/api/v1/admin/apphint`, { params: condition });
      return res.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  }

  async updateHint(hint) {
    try {
      const res = await window.axios.put('/api/v1/admin/apphint', hint);
      return res.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  }

  async deleteHint({ id }) {
    try {
      const res = await window.axios.delete(`/api/v1/admin/apphint?id=${id}`);
      return res.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  }

  async createHint(hint) {
    try {
      const res = await window.axios.post('/api/v1/admin/apphint', hint);
      return res.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  }
}

module.exports = HintService;
